module.exports = __webpack_public_path__ + "img/P689205803.5a2ea940.jpg";